export default {
	functional: true,
	name: 'Toast',
	props: {
		toast: {
			type: Object,
			require: true,
		},
	},
	render(h, context) {
		const { props } = context;
		const className = props.toast.position === 'bottom' ? 'global-toast-bottom' : 'global-toast-center';
		const children = [h('div', {}, props.toast.message)];

		if (props.toast.icon) {
			children.unshift(
				h('img', {
					class: 'global-toast-icon',
					domProps: {
						src: props.toast.icon,
					},
				})
			);
		}

		return h(
			'div',
			{
				class: [className, 'global-toast'],
			},
			children
		);
	},
};



// WEBPACK FOOTER //
// ./src/components/common/Toast.js